"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M16 5H4c-.5 0-1 .5-1 1v8c0 .5.5 1 1 1h12c.5 0 1-.5 1-1V6c0-.5-.5-1-1-1z"];
//# sourceMappingURL=symbol-rectangle.js.map